import React, { useEffect, useState } from "react";
import { usePermission } from "../../../../../core/hooks/PermissionHook";
import { constantsPermission } from "../../../../../Config/Constants";
import { useGetAddendaStatusLookupQuery } from "../../../../../services/EndPointsApis";

const ApprovalStatus = ({
  formik,
  projectLookups,
  addendaId,
  statusOfAddenda,
  projectId,
  viewOnly,
  isEditing,
  isReviewTitle,
  isApproved,
  setStatusInStatusModule,
  setStatusToSendInJobScope,
  isReviewed,
}: any) => {
  const { permissionList } = usePermission(
    constantsPermission?.moduleId?.addenda
  );
  //get addenda status
  const { data: addendaStatus, refetch } = useGetAddendaStatusLookupQuery({
    ProjectId: projectId,
    AddendaId: addendaId,
  });
  useEffect(() => {
    refetch()
  }, [])
  const [onchangeTrue, setOnchangeTrue] = useState(false)

  // Mapping permissions dynamically
  const allowedStatuses = projectLookups?.result?.Lst_AddendumStatus?.filter(
    (status: any) =>
      permissionList?.some(
        (permission: any) =>
          permission.name === status.value && permission.haveaccess
      )
  );

  const disbaled = permissionList?.some(
    (permission: any) => permission.haveaccess
  );

  useEffect(() => {
    if (onchangeTrue === false) {
      setStatusInStatusModule(formik?.values?.addendaStatus?.name)
    }
  }, [])

  return (
    <div className="row">
      <div className="col-md-12 mt-3">
        <h4>
          Addendum Status <span className="text-danger">*</span>
        </h4>
      </div>
      <div className="col-md-12 mt-2">
        <div className="radio-wrap">
          <div className="d-flex flex-wrap flex-column gap-4">
            {addendaStatus?.result?.map((status: any) => {
              const permission = permissionList.find(
                (p: any) => p.name === status.name
              );
              const isDisabled = permission ? !permission.haveaccess : true;
              const disabledbyApi = status?.isEnable === false
              return (
                <div className={`radio-btn ${isDisabled ? "disabled" : ""}`} key={status?.id}>
                  <input
                    type="radio"
                    className="status-radio"
                    id={status?.id?.toString()}
                    name="radioBtn"
                    value={status?.name}
                    checked={formik?.values?.addendaStatus?.id === status.id}
                    onChange={() => {
                      formik?.setFieldValue("addendaStatus.value", status?.name);
                      formik?.setFieldValue("status", status?.name);
                      formik?.setFieldValue("addendaStatus.id", status?.id);
                      setStatusInStatusModule(status?.name)
                      setStatusToSendInJobScope(status?.name)
                      setOnchangeTrue(true)
                    }}
                    disabled={isDisabled || disabledbyApi || viewOnly || (isEditing === true && isReviewTitle === false && isApproved === false) || (isEditing === true && isApproved === false && isReviewTitle === false)}
                  />
                  <label htmlFor={status?.id?.toString()}>{status?.name}</label>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApprovalStatus;
